import type { Fallacy } from "./types";
import { createStory } from "./types";

export const gishGallop: Fallacy = {
    id: "gish-gallop",
    name: "Gish Gallop",
    emoji: "🌊",
    category: "Jebakan Digital",
    description:
      "Membanjiri lawan dengan **banyak argumen sekaligus** agar kewalahan dan tak sempat membantah. Prinsipnya: **kuantitas, bukan kualitas**.",
    tldr: "Lempar 20 argumen sekaligus biar lawan gak sempat jawab — itu Gish Gallop.",
    detail:
      "Gish Gallop dinamai dari Duane Gish, seorang kreasionis yang terkenal dengan teknik **membanjiri lawan debat dengan puluhan klaim dalam waktu singkat**. Tujuannya bukan mencari kebenaran, tapi membuat lawan kewalahan.\n\nDi era digital, teknik ini makin marak — misalnya seseorang di grup WA yang kirim 10 link, 5 screenshot, dan 3 video sekaligus. Ketika kamu baru membantah satu poin, dia bilang: **'Tuh kan, yang lain gak bisa dijawab!'**\n\nKenapa ini menyesatkan? Karena **membantah satu klaim palsu butuh energi jauh lebih besar** daripada membuatnya. Ini disebut **'Brandolini's Law'**.\n\nCara melawan: Jangan terjebak merespons semuanya. **Pilih satu atau dua klaim utama**, minta lawan fokus di situ dulu. Kalau dia mengalihkan ke klaim lain, itu tanda Gish Gallop.",
    story: createStory("Gish Gallop", "🌊", {
      hook: {
        title: "Lawan debat kamu lempar 10 argumen sekaligus.",
        body: "Kamu baru bales satu, dia bilang: \"Tuh kan yang lain gak bisa dijawab!\" Kenal situasi ini?",
      },
      convo: {
        claim: "Aku bilang data BPS menunjukkan kemiskinan turun 0.5%. Langsung dibales **\"Beras naik, BBM naik, listrik naik, pengangguran tinggi, rupiah melemah, utang nambah!\"** Disuruh jawab semua sekaligus.",
        response: "10 klaim dilempar sekaligus biar gak sempat dibantah. **Kuantitas, bukan kualitas.**",
      },
      reveal: {
        body: "Taktik **membanjiri lawan dengan banyak argumen sekaligus** biar kewalahan. Prinsipnya: **kuantitas, bukan kualitas**.",
      },
      insight: {
        title: "Kenapa susah dilawan?",
        body: "Ngebantah satu klaim palsu butuh energi **jauh lebih besar** daripada bikin klaim palsu itu sendiri. Makanya yang nge-spam argumen selalu keliatan \"menang\".",
      },
      engagement: {
        title: "Paling sering kena Gish Gallop di mana?",
        body: "Grup WA keluarga atau kolom komentar politik? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["red-herring", "straw-man", "cherry-picking"],
  };
